@if (dataSource.data.length === 0 && !loading) {
  <p class="no-data">{{ noDataText }}</p>
} @else {
  <mat-table [dataSource]="dataSource" class="compact-table">
    <ng-container matColumnDef="No">
      <mat-header-cell *matHeaderCellDef>No.</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.No }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="Project">
      <mat-header-cell *matHeaderCellDef>Project</mat-header-cell>
      <mat-cell *matCellDef="let row">
        @if (row.ProjectNumber || row.ProjectName) {
          <div class="project-cell">
            @if (row.ProjectNumber) {
              <div class="project-number">{{ row.ProjectNumber }}</div>
            }
            @if (row.ProjectName) {
              <div class="project-name">{{ row.ProjectName }}</div>
            }
          </div>
        } @else {
          {{ row.Project || '—' }}
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="CreatedOn">
      <mat-header-cell *matHeaderCellDef>Created On</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.CreatedOn | date:'MM/dd/yyyy' }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="DaysOpen">
      <mat-header-cell *matHeaderCellDef>Days Open</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="badge {{ getDaysOpenClass(row.DaysOpen) }}">{{ row.DaysOpen }}</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Status">
      <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="status-badge" [ngClass]="getStatusClass(row.Status)">{{ row.Status || '—' }}</span>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
}

<mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>
